export default class UserIntegration {

  static integrationName = 'user';
  static enabled = true;
  static retry = 0;

  static setup() {
    return (typeof window.userengage === 'function');
  }

  static emit(fn, params) {
    this[fn](params);
  }

  static event({ eventName = 'default_1', data = {} }) {
    this.send(`event.${eventName}`, data);
  }

  static pageVisited({ pageName = 'default_2', data = {} }) {
    this.send(`event.${pageName} visited`, data);
  }

  static builderPageVisited({ pageName = 'default_4', campaignType = 'Generic', data = {} }) {
    return;
  }

  static productInteraction({ product_id = 0, event_type = 'view', data = {} }) {
    this.send('product_event', { product_id, event_type, ...data });
  }

  static send(key, params) {
    // eslint-disable-next-line no-undef
    window.userengage(key, params);
  }

}
